<template>
	<div class="main-checkout">
		<OrderTracking 
		v-if="tracking"
		:formRestaurant="false"
		@closeOrderTracking="tracking = $event">		
		</OrderTracking>
		<div class="container-check" v-if="current_data && !tracking">
			<div class="header-check">			
				<div class="checkout-name">
					<h5>Checkout</h5>
					<h4>Datos personales</h4>
				</div>
				<!--<div class="back-icon">
					<i class="fas fa-times" @click="close()"></i>
				</div>-->
			</div>
			<div class="content-check">
				<label for="" v-if="multipoints">Debe seleccionar un punto</label>
				<div class="payment-way" v-if="multipoints">
					<div class="pay-icon" v-bind:style="{backgroundColor : color_botones }">
						<i class="fas fa-map-marker-alt"></i>
					</div>
					<div class="pay-select">
						<select name="select" @change="changePoint()" v-model="form.id_point">
							<option value="0" disabled selected>Puntos...</option>
							<option :value="item.id_point" v-for="item in points" :key="item.id_point">{{ item.name }}</option>
						</select>
					</div>
				</div>
				<div class="first-info">
					<input type="text" class="c-name" placeholder="Nombres" v-model="form.nombres" autocomplete="off">
					<input type="text" class="c-phone" placeholder="Teléfono" v-model="form.telefono" autocomplete="off">
				</div>
				<input type="text" class="general" placeholder="Dirección" v-model="form.direccion" autocomplete="off" v-show="domicilioStatus">
				<input type="text" class="c-email general" placeholder="Email" v-model="form.email" autocomplete="off" v-if="status_email">
				<input type="text" class="general" placeholder="Cédula" v-model="form.cedula" autocomplete="off" v-if="statusCedula">
				<input type="text" class="general" placeholder="Barrio" v-model="form.barrio" autocomplete="off" v-if="statusBarrio">
				<div class="restaurant-date" v-if="status_date">
					<label for="">Fecha de entrega</label>
					<input type="date" class="data-deliver-day general" v-model="form.fecha_entrega" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
				<div class="rest-deliver-hour" v-if="status_hour">
				<label for="">Hora de entrega</label>
				<div class="select-hour">
					<select v-model="form.hora_entrega">
						<option value="0" disabled selected>Hora</option>
					</select>
					<select v-model="form.minuto_entrega">
						<option value="0" disabled selected>Minutos</option>
					</select>
					<select>
						<option value="43">AM</option>
						<option value="44">PM</option>
					</select>
				</div>	
				</div>
				<label for="">Métodos de pago</label>
				<div class="payment-way">
					<div class="pay-icon" v-bind:style="{backgroundColor : color_botones }">
						<i class="fas fa-money-bill"></i>
					</div>
					<div class="pay-select">
						<select name="select"  v-model="form.id_type_forma_pago" @change="verifyPayment()">
							<option value="0" disabled selected>Seleccione...</option>
							<option value="37" v-if="cash">Efectivo</option>
							<option value="38" v-if="transfer">Transferencia</option>
							<option value="39" v-if="dataphone">Datáfono</option>
							<option value="76" v-if="status_pay_online">Pago en linea</option>
						</select>
					</div>
				</div>
				<div class="bank-account" v-show="bank_transfer && bank_account.length > 0">
					<div class="account-select">
						<select name="select" id="select-bank" @change="copyAccount()">
							<option value="0" disabled selected>Seleccione para copiar N° de cuenta</option>
							<option :value="bank.id" v-for="bank in bank_account" :key="bank.id">{{ bank.bank }}</option>
						</select>
					</div>
				</div>
				<input type="text" class="general" placeholder="¿Con cuanto pagas?" autocomplete="off" v-if="status_37" v-model="form.pay_with">
				<input type="text" class="general comment" placeholder="Comentario" autocomplete="off" v-model="form.comentario">
				<!--<button class="confirm-order" id="conf-button" v-bind:style="{backgroundColor : color_botones }" @click="printData()">Confirmar orden</button>-->
				<div class="confirm-pedido" v-show="!checkout" id="conf-button" v-bind:style="{backgroundColor : color_botones }" @click="printData()">
					<h4 v-if="confirm">Confirmar orden</h4>
					<i class="fas fa-spinner" v-if="spinner"></i>
				</div>
				<div v-show="checkout" style="width: 100%;">    
      				<button class="btn-wonpi" @click="pay()">Paga Aquí</button>     
    			</div>
    			<button class="back-button" v-bind:style="{color : color_botones, borderColor: color_botones }" @click="close()">Volver</button>
			</div>
			<div class="out-service" v-if="out_point">
				<div class="avisment">
					<i class="far fa-clock"></i>
					<h4>Este punto está fuera de horario</h4>
					<button @click="out_point = false">Aceptar</button>
				</div>
			</div>
			<div class="out-service" v-if="require_shields">
				<div class="avisment">
					<i class="far fa-clock"></i>
					<h4>Los campos son obligatorios</h4>
					<button @click="require_shields = false">Aceptar</button>
				</div>
			</div>
		</div>
		<!--<div class="personal-container" v-if="personal_data && !tracking">
			<div class="abstract" v-bind:style="{backgroundColor : color_botones }">
				<h4>Datos personales</h4>
				<i class="fas fa-times" @click="close()"></i>
			</div>
			<div class="actual-data">
				<div class="data">
					<h5>Punto de atención:</h5>
					<h4>{{ actual_info.punto }}</h4>
				</div>
				<div class="both-data">
					<div class="current_info">
						<h5>Nombre:</h5>
						<h4>{{ actual_info.nombre }}</h4>
					</div>
					<div class="current_info">
						<h5>Teléfono:</h5>
						<h4>{{ actual_info.telefono }}</h4>
					</div>
				</div>
				<div class="data" v-show="domicilioStatus">
					<h5>Dirección:</h5>
					<h4>{{ actual_info.direccion }}</h4>
				</div>
				<div class="data" v-show="statusBarrio">
					<h5>Barrio:</h5>
					<h4>{{ actual_info.barrio }}</h4>
				</div>
				<div class="data">
					<h5>Método de pago:</h5>
					<h4>{{ actual_info.payment }}</h4>
				</div>
				<div class="data-last">
					<h5>Comentario:</h5>
					<h4>{{ actual_info.comment }}</h4>
				</div>
				<div class="edit-button">
					<h5 v-bind:style="{color : color_botones }" @click="editData()">Editar mis datos</h5>
				</div>
			</div>
			<div class="actual-data-button">
				<button class="confirm-order" v-bind:style="{backgroundColor : color_botones }" @click="printData()">Confirmar orden</button>
			</div>
		</div>-->
	</div>
</template>

<style type="text/css" scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	*:focus{
		outline: none;
	}

	.btn-wonpi{
      	display: inline-block;
      	background-color: rgb(26, 69, 148);
      	border: 0px;
      	border-radius: 10px;
      	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      	font-weight: 600;
      	font-size: 16px;
      	border-top-left-radius: 22px;
	  	border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border-top-right-radius: 0 !important;
		padding: 11px;
      	color: white;
      	cursor: pointer;
      	-webkit-font-smoothing: subpixel-antialiased;
      	width: 100%;
      	margin-top:10px;
  	}

  	.back-button{
  		width: 100%;
		padding: 12px 25px;
		border-radius: 5px; 
		margin-top:15px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		background: transparent;
		box-shadow: none;
		border: 1px solid;
  	}

	.btn-wonpi::before {
	    content: "";
	    display: inline-block;
	    width: 16px;
	    height: 16px;
	    background-image : url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 229.5 229.5'%3E%3Cpath fill='%23fff' d='M214.419 32.12A7.502 7.502 0 0 0 209 25.927L116.76.275a7.496 7.496 0 0 0-4.02 0L20.5 25.927a7.5 7.5 0 0 0-5.419 6.193c-.535 3.847-12.74 94.743 18.565 139.961 31.268 45.164 77.395 56.738 79.343 57.209a7.484 7.484 0 0 0 3.522 0c1.949-.471 48.076-12.045 79.343-57.209 31.305-45.217 19.1-136.113 18.565-139.961zm-40.186 53.066l-62.917 62.917c-1.464 1.464-3.384 2.197-5.303 2.197s-3.839-.732-5.303-2.197l-38.901-38.901a7.497 7.497 0 0 1 0-10.606l7.724-7.724a7.5 7.5 0 0 1 10.606 0l25.874 25.874 49.89-49.891a7.497 7.497 0 0 1 10.606 0l7.724 7.724a7.5 7.5 0 0 1 0 10.607z'/%3E%3C/svg%3E");
	    background-size:contain;
	    background-repeat: no-repeat;
	    vertical-align: middle;
	    margin-right: 8px;
	    transform: translateY(-2px);
	}

	.confirm-pedido{
		width: 100%;
		padding: 12px 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		margin-top:15px;
	}

	.confirm-pedido h4{
		color: #fff;
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
	}

	.confirm-pedido i{
		color: #fff;
		font-size: 17px;
		animation: rotar 2s infinite;
	}

	@keyframes rotar {
		from{
			transform: rotate(0deg);
		}
		to{
			transform: rotate(360deg);
		}
	}

	.account-select{
		width: 100%;
	}

	.out-service{
		width: 100%;
		height: 100vh;
		position: absolute;
		top: 0;
		background: rgba(0,0,0,.7);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.avisment{
		width: 75%;
		background: #fff;
		box-shadow: 0px 8px 15px 0px rgba(125,125,125,1);
		padding-top: 25px;
		border-radius: 15px;
		overflow: hidden;
	}

	.avisment i{
		font-size: 55px;
		color: #FA5151;
		margin-bottom: 10px;
	}

	.avisment h4{
		font-size: 15px;
		color: #6A6A6A;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		padding-bottom: 10px;
	}

	.avisment button{
		width: 100%;
		background: #fff;
		border-top: 1px solid #CBCBCB;
		border-right: none;
		border-left: none;
		border-bottom: none;
		padding: 10px;
		padding-bottom: 15px;
		font-size: 16px;
		color: #FA5151;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
	}

	.account-select select{
		width: 100%;
		color: #12243C;
		padding-top: 12px;
		padding-bottom: 12px;
		padding-left: 8px;
		padding-right: 19px;
		cursor: pointer;
		color: #757575;
		background: transparent;
		border: none;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	  	font-family: 'Poppins', sans-serif;
	  	color: #9e9e9e;
		font-size: 15px;
	}

	.bank-account{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-top-left-radius: 30px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		padding: 4px;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.actual-data-button{

		width: 100%;
		padding-left: 20px;
		padding-right: 20px;
		padding-top: 35px;
	}

	.edit-button{
		width: 100%;
		text-align:right;
		padding: 15px 20px;
	}

	.edit-button h5{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 16px;
		text-decoration-line: underline;
	}

	.data{
		padding-top: 15px;
		padding-right: 20px;
		padding-left: 20px;
		padding-bottom:10px;
		text-align: left;
		border-bottom: 1px solid #f2f2f2;
	}

	.data-last{
		padding-top: 15px;
		padding-right: 20px;
		padding-left: 20px;
		padding-bottom:10px;
		text-align: left;
	}

	.data-last h5{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 14px;
		margin-bottom: 2px;
		color: #bfbfbf;
	}

	.data-last h4{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 17px;
	}

	.data h5{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 14px;
		margin-bottom: 2px;
		color: #bfbfbf;
	}

	.data h4{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 17px;
	}

	.current_info{
		text-align: left;
		width: 50%;
		padding: 20px;
	}

	.current_info h5{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 14px;
		margin-bottom: 2px;
		color: #bfbfbf;
	}

	.current_info h4{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 17px;
		margin-bottom: 0;
	}

	.both-data{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 5px;
		border-bottom: 1px solid #f2f2f2;
	}

	.personal-container{
		width: 100%;
		height: auto;
	}

	.abstract{
		width: 100%;
		padding: 20px;
		height: 25vh;
		display: flex;
		justify-content: space-between;
	}

	.abstract h4{
		color: #fff;
		font-family: 'Poppins', sans-serif;
		font-size:22px;
	}

	.abstract i{
		color: #fff;
		font-size:22px;
		font-weight: 600;
	}

	.actual-data{
		margin: 0 auto;
		width: 85%;
		height: auto;
		border-radius: 10px;
		box-shadow: 0px 8px 15px 0px rgba(245,245,245,1);
		margin-top: -80px;
		background: #fff;
	}

	.confirm-order{
		width: 100%;
		font-family: 'Poppins', sans-serif;
		font-size:18px;
		font-weight: 500;
		border: none;
		border-radius: 5px;
		padding:15px;
		color: #fff;
		margin-top:15px;
	}

	.send-whats{
		width: 100%;
		font-family: 'Poppins', sans-serif;
		font-size:18px;
		font-weight: 500;
		border: none;
		border-radius: 5px;
		padding:15px;
		color: #fff;
		margin-top:15px;
		background: #64B161;
	}

	.send-whats i{
		margin-right: 5px;
		color: #fff;
		font-size: 18px;
	}

	.select-hour{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}

	.select-hour select{
		color: #12243C;
		padding: 14px 15px;
		cursor: pointer;
		color: #757575;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	  	border-top-left-radius: 21px;
		border-bottom-left-radius: 21px;
		border-bottom-right-radius: 21px;
		background-color: #F8F6FB;
		border: 1px solid #cccccc;
	}

	.select-hour select:nth-child(1){
		width: 28%;
	}

	.select-hour select:nth-child(2){
		width: 40%;
	}

	.select-hour select:nth-child(3){
		width: 25%;
	}

	input[type="date"]:not(.has-value):before{
  		color: #757575;
 		content: attr(placeholder);
	}

	input[type="date"].has-value{
  		width: 100%;
		border-top-left-radius: 25px;
		border-bottom-left-radius: 25px;
		border-bottom-right-radius: 25px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding: 14px 15px;
	}

	input[type="time"]:not(.has-value):before{
  		color: #757575;
 		content: attr(placeholder);
	}

	.first-info{
		width: 100%;
		display:flex;
		justify-content: space-between;
		align-items: center; 
	}

	.c-name{
		width: 49%;
		border-top-left-radius: 25px;
		border-bottom-left-radius: 25px;
		border-bottom-right-radius: 25px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding: 14px 15px;
	}

	.c-phone{
		width: 49%;
		border-top-left-radius: 25px;
		border-bottom-left-radius: 25px;
		border-bottom-right-radius: 25px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding: 14px 15px;
	}
	
	.header-check{
		width: 100%;
		padding: 20px 25px 5px 25px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.back-icon{
		width: 25%;
		text-align: right;
	}

	.back-icon i{
		font-size: 21px;
		color: #676767;
		margin-bottom: .5rem;
		align-self: center;
		font-weight: 600 !important;
	}

	.checkout-name{
		width: 75%;
		text-align: left;
	}

	.checkout-name h4{
		font-size: 21px;
		font-weight: 500;
		color: #000;
		font-family: 'Poppins', sans-serif;
	}

	.checkout-name h5{
		font-size: 15px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		margin-bottom: 2px;
		color: #C8C8C8;
	}

	.content-check{
		width: 100%;
		padding: 15px;
		text-align: left;
	}

	.content-check label{
		font-family: 'Poppins', sans-serif;
		padding-left: 8px;
	}

	.general{
		width: 100%;
		border-top-left-radius: 25px;
		border-bottom-left-radius: 25px;
		border-bottom-right-radius: 25px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding: 14px 15px;
		/*box-shadow: 0px 8px 10px 0px rgba(230,230,230,1);*/
	}

	::placeholder{
		color: #9e9e9e;
		font-size: 15px;
		font-family: 'Poppins', sans-serif;	
	}

	.payment-way{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #F8F6FB;
		border-top-left-radius: 30px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
		border: 1px solid #cccccc;
		padding: 4px;
		margin-top: 1px;
		margin-bottom: 15px;
	}

	.pay-icon{
		width: 46px;
		height: 46px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.pay-icon i{
		color: #fff;
	}

	.pay-select{
		width: 90%;
	}

	.pay-select select{
		width: 100%;
		color: #12243C;
		padding-top: 12px;
		padding-bottom: 12px;
		padding-left: 8px;
		padding-right: 19px;
		cursor: pointer;
		color: #757575;
		background: transparent;
		border: none;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	  	font-family: 'Poppins', sans-serif;
	  	color: #9e9e9e;
		font-size: 15px;
	}

	.comment{
		height: 90px;
	}

</style>

<script>
	import moment from 'moment';
	import axios from 'axios';
	import OrderTracking from './OrderTracking';
	import { osName } from 'mobile-device-detect';
	export default{
		props: ['data'],
		components:{
			OrderTracking
		},
		data(){
			return {
				dominio: localStorage.getItem('custom_dominio'),
				uri: localStorage.getItem('license_uri'),
				confirm: true,
				spinner: false,
				mensaje: "",
				tracking: false,
				require_shields: false,
				out_point:false,
				multipoints: false,
				personal_data:false,
				current_data:true,
				socketTable:'',
				socket: "",
				status_pay_online: JSON.parse(localStorage.getItem('status_pay_online')),
				actual_info: JSON.parse(localStorage.getItem('client_info')),
				statusCedula: JSON.parse(localStorage.getItem('r_cedula')),
				statusBarrio: JSON.parse(localStorage.getItem('r_barrio')),
				domicilioStatus: JSON.parse(localStorage.getItem('domicilio_status')),
				status_recogida: JSON.parse(localStorage.getItem('status_recogida')),
				status_hour: false,
				status_date: false,
				nameOS: osName,
				status_email: JSON.parse(localStorage.getItem('r_email')),
				cash: JSON.parse(localStorage.getItem('cash')),
				transfer: JSON.parse(localStorage.getItem('transfer')),
				dataphone: JSON.parse(localStorage.getItem('dataphone')),
				points: JSON.parse(localStorage.getItem('puntos')),
				bank_account: JSON.parse(localStorage.getItem('banks_accounts')),
				id_companie : localStorage.getItem('companie_id'),
				color_botones: localStorage.getItem('color_licencia'),
				status_37: false,
				bank_transfer: false,
				jornada: JSON.parse(localStorage.getItem('jornada')),
				seguimiento_pedido: JSON.parse(localStorage.getItem('seguimiento_pedido')),
				seguimiento_pedido_wpp: JSON.parse(localStorage.getItem('seguimiento_pedido_wpp')),
				horarios: JSON.parse(localStorage.getItem('horarios')),
				point_name: "",
				socketTracking:'',
				form: {
					id_point: 0,
					order_total:0,
					nombres: "",
					telefono: "",
					direccion: "",
					email: "",
					cedula: "",
					barrio: "",
					id_companie :localStorage.getItem('companie_id'),
					domicilio: localStorage.getItem('domicilio'),
					fecha_entrega: "",
					hora_entrega: "",
					mesa: 0,
					minuto_entrega: "",
					latitude: 0,
					longitude: 0,
					id_type_forma_pago: 0,
					comentario: "",
					descuento: 0,
					id_coupon: 0,
					pay_with: "",
					cart:[]
				},
				formasPago:[
		          {id: 37, text: 'Efectivo'},
		          {id: 38, text: 'Transferencia'},
		          {id: 39, text: 'Datáfono'},
		          {id: 76, text: 'Pago en linea'},
		        ],
		        telefono_pedidos: "",
		        namePoint: "",
		        checkout: false,        
		        formPay:{
		          id_order: false,
		          payOnline: false,
		          wompiPublicKey: '',
		          wompiCurrency: '',
		          wompiReference: '',
		          redirectUrl: ''
		        }
			}
		},
		watch:{
			
		},
		methods:{
			pay(){
			    if(!this.validateShields()) return 0;   
			    var self = this;
			    axios
			    .get('https://back.vinapp.co/api/order/get-data-wompi/'+this.form.id_companie)
			    .then( res =>{
			      this.formPay.wompiPublicKey = res.data.wpk;
			      this.formPay.wompiCurrency = res.data.wc;
			      this.formPay.wompiReference = res.data.wr;
			      this.formPay.redirectUrl = res.data.wp_redirect_url;
			      self.checkout = new WidgetCheckout({
			        currency: self.formPay.wompiCurrency,
			        amountInCents: parseFloat(String(self.form.order_total)+'00'),
			        reference: self.formPay.wompiReference,
			        publicKey: self.formPay.wompiPublicKey,
			        redirectUrl: `${window.location.origin}${self.formPay.redirectUrl}${self.formPay.wompiReference}`
			      });
			      self.executeWompi();
			    })
			    .catch( err => {
			      console.log(err);
			    });
			},
			executeWompi(){
			    var self = this;
			    self.saveOrder(true,this.formPay.wompiReference,true);
			    this.checkout.open(function ( result ) { 
			      var transaction = result.transaction
			      if(transaction.status == 'APPROVED'){
			        self.enviarWhatsApp(true,transaction.id, false,true);
			      }else{
			        self.form.id_type_forma_pago = 0;
			        self.checkout = false; 
			      }
			    });
			},
			enviarWhatsApp(wompi,wompi_id = "",retornar = false){
				if (this.multipoints) {
					//Tomamos el id del punto para buscar el telefono del domicilio
          			var idPoint = this.form.id_point;          
          			let self = this;
          			this.points.forEach(function(point){
			           if(point.id_point == idPoint){              
			            self.telefono_pedidos = point.telefono_pedidos;
			            self.namePoint = point.name;
			           }
			        });
				}
				//construimos el mensaje para wapp
      			//se agregan los espacios al nombre de la empresa
      			this.mensaje = '';
      			let nombre_comercial = localStorage.getItem('nombre_comercial');
      			nombre_comercial = nombre_comercial.replace(" ","%20");
      			let nombre = this.form.nombres;
      			nombre = nombre.replace(" ","%20");
      			var value = 0;
			    var reemplazar="";
			    this.mensaje += `
			    https://wa.me/${this.telefono_pedidos}?text=Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20una%20compra.`;
			    let direccion = this.form.direccion;
			    let direccion_pedido = '';
			    direccion = direccion.replace("#",'%23');
			    direccion = direccion.split(' ');
			    let tamaño = direccion.length;
		        direccion.forEach((parte,index)=>{
		            index += 1;
		            if(index < tamaño){
		              direccion_pedido += `${parte}%20`
		            }else{
		              direccion_pedido += `${parte}`
		            }
		        });  
			    this.mensaje += '%0A%0A';
			    this.mensaje += `*Celular:*%20${this.form.telefono}`;
			    this.mensaje += '%0A';//un espacio 
			    if (!this.status_recogida) {
			    	this.mensaje += `*Dirección:*%20${direccion_pedido}`;
			    }
			    if (this.statusCedula) {
			    	this.mensaje += '%0A';//un espacio  
			        this.mensaje +=  `*Cédula:*%20${this.form.cedula}`;
			    }
			    if (this.statusBarrio) {
			    	this.mensaje += '%0A';//un espacio  
			        this.mensaje +=  `*Barrio:*%20${this.form.barrio}`;
			    }
			    if (this.status_email) {
			    	this.mensaje += '%0A';//un espacio  
			        this.mensaje +=  `*Email:*%20${this.form.email}`;
			    }
			    this.mensaje += '%0A%0A';
			    this.mensaje += '*Detalle de la orden:*';
			    this.mensaje += '%0A';
			    this.data.forEach((item)=>{
			      value = 0;
			      this.mensaje += `-%20${item.cantidad}%20x%20`;
			      reemplazar = item.name_product;
			      reemplazar = reemplazar.replace(" ","%20");
			      value = (parseInt(item.valor)*item.cantidad)
			      if(item.combination)this.mensaje += `-%20${reemplazar}%20(${item.combination})%20(%24%20${new Intl.NumberFormat("de-DE").format(value)})`;
				  else this.mensaje += `-%20${reemplazar}%20(%24%20${new Intl.NumberFormat("de-DE").format(value)})`;			      
			      this.mensaje += '.%0A%0A';
			    });
			    if (this.form.descuento > 0) {
			    	this.mensaje += `*Descuento%3A*%20%24%20${new Intl.NumberFormat("de-DE").format(this.form.descuento)}`;
			        this.mensaje += '%0A%0A';
			    }
			    if ((this.domicilioStatus || this.status_recogida || this.form.mesa > 0) && this.multipoints) {
			    	this.mensaje += `*Punto de Atención%3A*%20${this.namePoint}`;
        			this.mensaje += '%0A';
			    }
			    if(this.form.mesa != 0 && !this.status_recogida){
			       this.mensaje += `*Mesa%3A*%20${this.form.mesa}`;
			       this.mensaje += '%0A%0A'; 
			    }	
			    if(this.form.domicilio > 0 && this.domicilioStatus){      
			      this.mensaje += `*Envío a domicilio:*%20%24%20${this.form.domicilio}`;
			      this.mensaje += '.%0A';
			    }
			    var textForma = this.form.id_type_forma_pago;    
			    this.formasPago.forEach(function(f){
			        if(textForma == f.id)textForma = f.text;
			    });
			    //definimos la forma de pago.      
			    this.mensaje += `*Forma de Pago%3A*%20${textForma}`;
			    this.mensaje += '%0A';
			    let cuenta = "";
      			let banco = "";
			    if (this.form.id_type_forma_pago == 38) {
			        cuenta = document.getElementById('select-bank').value;
			        this.bank_account.forEach((item) =>{
			          if (item.id == cuenta) {
			            banco = item.bank;
			            cuenta = item.account;
			          }
			        });
			        if (cuenta > 0) {
			          this.mensaje += '%0A';
			          this.mensaje += `*Banco%3A*%20${banco}`;
			          this.mensaje += '%0A';
			          this.mensaje += `*Numero de cuenta%3A*%20${cuenta}`;
			          this.mensaje += '%0A';
			        }
			    }
			    if (this.status_37) {
			    	if (this.form.pay_with) {
			    		this.mensaje += `*Paga con%3A*%20%24%20${this.form.pay_with}`;
			    	}else{
			    		this.mensaje += `*Paga con%3A*%20Sin definir.`;
			    	}
			    	this.mensaje += '%0A%0A'; 
			    }
			    if(wompi && !retornar){
			      this.mensaje += `*Pago en Wompi*`; 
			      this.mensaje += '%0A';
			      this.mensaje += `*Id de la transacción%3A*%20${wompi_id}`;
			      //this.mensaje += `*Referencia de pago%3A*%20${this.formPay.wompiReference}`;
			      this.mensaje += '%0A%0A'; 
			      this.form.id_type_forma_pago = 0;
			      this.checkout = false;  
			    }

			    if(retornar){
			      this.mensaje += `*Pago en Wompi*`; 
			      this.mensaje += '%0A';
			      this.mensaje += `*Id de la transacción%3A*%20reemplazar`;
			      this.mensaje += '%0A%0A';
			    }
			    this.mensaje += `*Total del pedido%3A%20%24%20${new Intl.NumberFormat("de-DE").format(this.form.order_total)}*`;
			    this.mensaje += '%0A';
			    this.mensaje += `*Comentario%3A*%20${this.form.comentario}`;
			    this.mensaje += '%0A';
			    if (this.seguimiento_pedido_wpp) {
			    	this.mensaje += '%0A';
			    	this.mensaje += `*Puedes ver el progreso de tu pedido en el siguiente enlace:*`;
			    	this.mensaje += '%0A';
			    	if (this.dominio) {
			    		this.mensaje += `${location.origin}`+`/`+`${this.uri}`;
			    	}else{
			    		this.mensaje += `${location.origin}`;
			    	}
			    	
			    }
			    if (this.form.domicilio == 0 && this.domicilioStatus) {
			    	this.mensaje += '%0A%0A';  
       	 			this.mensaje += `El valor del domicilio será confirmado en un momento de acuerdo a la dirección`;
			    }
			    this.mensaje += '%0A%0A';
      			this.mensaje += `Gracias.`;
			    location.href = this.mensaje;

			},
			editData(){
				this.current_data=true;
				this.personal_data=false;
			},
			setValues(){
				if (localStorage.getItem('obj_coupon')) {
					this.id_coupon = JSON.parse(localStorage.getItem('obj_coupon')).id_coupon;
				}else{
					this.id_coupon = 0;
				}
				if (localStorage.getItem('obj_coupon')) {
					this.descuento = JSON.parse(localStorage.getItem('obj_coupon')).discount;
				}else{
					this.discount = 0;
				}				
			},
			validateFields(){
				let status_shield = true;

				if (this.statusCedula) {
					if (!this.form.cedula) status_shield = false;
				}
				if (this.statusBarrio) {
					if (!this.form.barrio) status_shield = false;
				}
				if (this.status_email) {
					if (!this.form.email) status_shield = false;
				}
				if (this.status_email) {
					if (!this.form.email) status_shield = false;
				}
				if(this.domicilioStatus){
					if (!this.form.direccion) status_shield = false;
				}
				if (!this.form.nombres) status_shield = false;
				if (!this.form.telefono) status_shield = false; 
				if (this.form.id_type_forma_pago == 0) status_shield = false; 
				if (this.form.id_point == 0) status_shield = false;
				return status_shield;
			},
			verifyForm(){
				/*if (localStorage.getItem('client_info')) {
					this.personal_data = true;
					this.current_data = false;
					//Llenamos los inputs del formulario con sus valores correspondientes
					this.form.nombres = this.actual_info.nombres;
					this.form.telefono = this.actual_info.telefono;
					this.form.direccion = this.actual_info.direccion;
					this.form.email = this.actual_info.email;
					this.form.cedula = this.actual_info.cedula;
					this.form.barrio = this.actual_info.barrio;
					this.form.comentario = this.actual_info.comment; 
				}else{
					this.current_data = true;
					this.personal_data = false;
				}*/
			},
			saveStorage(){
				//Guardamos el texto de la forma de pago preguntando por el ID
				let text_forma = this.form.id_type_forma_pago;
				this.formasPago.forEach(function(f){
			        if(text_forma == f.id)text_forma = f.text;
			    });
			    //Creamos el objeto para guardarlo en el localStorage
				let client_info = {
					punto: this.point_name,
					nombres: this.form.nombres,
					telefono: this.form.telefono,
					direccion: this.form.direccion,
					email: this.form.email,
					cedula: this.form.cedula,
					barrio: this.form.barrio,
					payment: text_forma,
					comment: this.form.comentario
				}
				localStorage.setItem('client_info', JSON.stringify(client_info));
				localStorage.setItem('telefono', this.form.telefono);
			},
			changePoint(){
				var self = this;
				this.out_point = false;
				document.getElementById("conf-button").disabled = false; 
      			if(this.jornada){
      				 let id = this.form.id_point;
				     let now = moment().format('YYYY-MM-DD HH:mm');
				     let date = moment().format('YYYY-MM-DD');
				     let diaSemana = moment().format('LLLL');
				     diaSemana = diaSemana.split(',')[0];
				     diaSemana = this.toSpanishDay(diaSemana);  
				     this.points.forEach(function(p,i){
				     	if(id == p.id_point){
				     		self.point_name = p.name;
				     		let horario = self.horarios[i];
				     		horario.forEach(function(h){                  
			                  if(h.id_tipo_horario == diaSemana || h.id_tipo_horario == 49){  
			                    if(moment(now).isBetween(date+' '+h.am_apertura, date+' '+h.am_cierre) || moment(now).isBetween(    date+' '+h.pm_apertura, date+' '+h.pm_cierre)){
			                        document.getElementById("conf-button").disabled = false;                       
			                      }else{
			                        self.out_point = true;
			                        document.getElementById("conf-button").disabled = true; 
			                      }	
			                  }
			              });
				     	}
				     });
      			}
			},
			toSpanishDay(day){
			      if(day == 'Monday') return 42;
			      if(day == 'Tuesday') return 43;
			      if(day == 'Wednesday') return 44;
			      if(day == 'Thursday') return 45;
			      if(day == 'Friday') return 46;
			      if(day == 'Saturday') return 47;
			      if(day == 'Sunday') return 48;
    		},
			close(){
				this.$emit('closeCheckout',false);
			},
			printData(pay_online,wp_reference = "",wp_wapp = false){
				//Preguntamos si todos los campos están gestionados y mandamos a guardar en el local storage
				if (this.validateFields()) {
					this.confirm = false;
					this.spinner = true;
					this.saveStorage();
					this.form.cart=JSON.stringify(this.data);   
			        this.form['estado_domicilio'] = this.domicilioStatus;       
			        this.form['total'] = this.form.order_total;
			        this.form['os'] = this.nameOS;
			        //this.form['entrega'] = "";
			        this.form['wp_reference'] = wp_reference;
			        if(wp_wapp){
			        	this.form['wp_wapp'] = this.enviarWhatsApp(false,null,true);
			        }  
			        var _self = this;
			        axios.post('https://back.vinapp.co/api/order/save-order-end',this.form)
			        .then(res => {   
                           if (res.data.status==200) {
                           		this.spinner = false;
                           		this.confirm = true;
                              	this.tracking=true;
                              	this.form['id_order']=res.data.new_id_order;
                              	localStorage.setItem('id_order', res.data.new_id_order);
                              	localStorage.setItem('id_punto', this.form.id_point);
                              	if (this.$route.params.mesa > 0) {
                              		localStorage.setItem(`id_estado_order_${this.id_companie}_${this.form.mesa}`,91);
                              	}else{
                              		localStorage.setItem(`id_estado_order_${this.id_companie}`,91);
                              	}
                              	if( _self.seguimiento_pedido){ 
                              	  console.log('voy para seguimiento')                   
			                      	//_self.emitSocketTracking(this.form.id_point);        
			                    }
			                    if (!pay_online) {
			                    	_self.enviarWhatsApp(false);
			                    }
			                }
			            })
			         .catch(err => {
			            console.log(err);      
			         });
				}else{
					this.require_shields = true;
				}
			},
			emitSocketTracking(id_point){
			    console.log(id_point)
               this.socket.emit("setup seguimiento",{id_point:id_point});
			},
			copyAccount(){      
		        document.getElementById('notify-copy').style.display = 'block';
		        setTimeout(function(){ document.getElementById('notify-copy').style.display = 'none'; }, 3000);     
		        var aux = document.createElement("input");
		        aux.setAttribute("value", document.getElementById('select-bank').value);
		        document.body.appendChild(aux);
		        aux.select();
		        document.execCommand("copy");
		        document.body.removeChild(aux);  
    		},
    		verifyPayment(){
  				if (this.form.id_type_forma_pago == 38) {
  					this.bank_transfer = true;
  				}else{
  					this.bank_transfer = false;
  				}
  				if (this.form.id_type_forma_pago == 37) {
  					this.status_37 = true;
  				}else{
  					this.status_37 = false;
  				}
  				if (this.form.id_type_forma_pago == 76)this.checkout = true;
  			},
  			ValidatePoints(){
  				if (this.points.length > 1) {
  					this.multipoints = true
  				}else{
  					this.multipoints = false;
  					this.form.id_point = this.points[0].id_point;
  				}
  			},
  			validatePoint(){
  				if (this.form.id_point == 211) {
  					this.out_point = true;
  				}
  			}
		},
		created(){
			//this.socket = io(`https://back.vinapp.co:3002`,{transports: ['websocket'], upgrade: false})
		},
		mounted(){
			this.data.forEach((item) => {
				this.form.order_total += (parseInt(item.valor)*item.cantidad)
			});
			if (this.form.domicilio > 0) {
				this.form.order_total += parseInt(this.form.domicilio);
			}
			//this.socket = io(`https://back.vinapp.co:3002`,{transports: ['websocket'], upgrade: false})
			this.setValues();
			this.ValidatePoints();
			this.verifyForm();
			if(this.$route.params.mesa)this.form.mesa = this.$route.params.mesa;
        	localStorage.setItem('mesa', this.form.mesa)

		}
	}
</script>